/*
 * *
 *   ~  * Copyright (c) by INFODATA-GROUP. All rights reserved.
 *   ~  * No part of this publication may be reproduced, distributed,
 *   ~  * or transmitted in any form or by any means, including photocopying, recording,
 *   ~  * or other electronic or mechanical methods, without the prior written permission of the publisher,
 *   ~  * except in the case of brief quotations embodied in critical
 *   ~  * reviews and certain other noncommercial uses permitted by copyright law.
 *   ~  * AUTHOR : bs
 *   ~  * DATE : 30/07/2025 10:59
 *
 */

import { SettingsService } from '@infodata-group/inf-commons';
import { SerializedFolderInterface } from '../../interface/serialized/serialized-folder.interface';
import { SerializedCompanyPresetInterface } from '../../interface/serialized/serialized-company-preset.interface';
import { PreferencesSettingsKeyEnum } from '@monorepo-projects/alwayson-shared';
import { SerializedPresetInterface } from '../../interface/serialized/serialized-preset.interface';

export class ToolsPresetMigration {
  public static migrateToCompanyPreset(
    currentCompany: string,
    settingsService: SettingsService,
  ) {
    if (!currentCompany) {
      return;
    }

    const oldPresets = settingsService.getSetting(
      'presets',
    ) as SerializedFolderInterface[];
    if (!oldPresets) {
      return;
    }
    if (!Array.isArray(oldPresets)) {
      return;
    }
    if (oldPresets.length === 0) {
      return;
    }

    const companyPresets: SerializedCompanyPresetInterface[] = [
      {
        id: currentCompany,
        label: '',
        createdAt: new Date().getTime(),
        updatedAt: new Date().getTime(),
        folders: oldPresets,
      },
    ];
    settingsService.addSetting(
      PreferencesSettingsKeyEnum.companyPresets,
      companyPresets,
    );
    // Old presets are no longer needed
    delete settingsService.settings['presets'];
  }

  public static migrateToPresetV2(settingsService: SettingsService) {
    const data: SerializedCompanyPresetInterface[] = settingsService.getSetting(
      PreferencesSettingsKeyEnum.companyPresets,
    );
    const oldData = JSON.stringify(data);
    data.forEach((d) => {
      d.folders.forEach((f) => {
        f.presets.forEach((p) => {
          if (p.version === 2) {
            return;
          }
          ToolsPresetMigration.applyDisplay(p, 'blackboxes');
          ToolsPresetMigration.applyDisplay(p, 'materials');
          ToolsPresetMigration.applyDisplay(p, 'sites');
          p['version'] = 2;
          p.updatedAt = new Date().getTime();
        });
      });
    });
    // No change, no need to update
    if (oldData === JSON.stringify(data)) {
      return;
    }
    settingsService.addSetting(PreferencesSettingsKeyEnum.companyPresets, data);
  }

  private static applyDisplay(
    preset: SerializedPresetInterface,
    type: 'blackboxes' | 'materials' | 'sites',
  ) {
    let arrayKey = '';
    let displayKey = '';
    switch (type) {
      case 'blackboxes':
        arrayKey = 'selectedBbxId';
        displayKey = 'blackboxesDisplay';
        break;
      case 'materials':
        arrayKey = 'selectedMaterialsId';
        displayKey = 'materialsDisplay';
        break;
      case 'sites':
        arrayKey = 'selectedSitesId';
        displayKey = 'sitesDisplay';
        break;
      default:
        throw Error('Wrong type');
    }
    if (preset[displayKey] !== undefined) {
      return;
    }
    if (preset[arrayKey].length > 0) {
      preset[displayKey] = 'selection';
      return;
    }
    if (
      preset[arrayKey].length === 0 &&
      (preset.id === 'default' || preset.id === 'map-default')
    ) {
      preset[displayKey] = 'all';
      return;
    }
    preset[displayKey] = 'none';
  }
}
